<template>
  <div>
    <a-card :title="$t('移库单详情')">
      <a-button slot="extra" type="primary" ghost icon="left" @click="$router.go(-1)">{{ $t("返回") }}</a-button>
      <section id="printContent">
        <a-spin :spinning="orderLoading">
          <img class="jsbarcode" id="jsbarcode" ref="jsbarcode" />
          <a-descriptions bordered>
            <a-descriptions-item :label="$t('移库单号')">
              {{ locationTransferOrderItem.number }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('仓库')">
              {{ locationTransferOrderItem.warehouse_name }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('状态')">
              {{ locationTransferOrderItem.is_void ? $t("已作废") : $t("已完成") }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('创建人')">
              {{ locationTransferOrderItem.creator_name }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('创建时间')">
              {{ locationTransferOrderItem.create_time }}
            </a-descriptions-item>
          </a-descriptions>
        </a-spin>
        <div style="margin-top: 16px">
          <a-table
            rowKey="id"
            size="small"
            :columns="columns"
            :data-source="locationTransferMaterialItems"
            :loading="materialLoading"
            :pagination="false"
            :scroll="{ x: 1020 }"
          >
          </a-table>
        </div>
      </section>
    </a-card>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
import { locationTransferOrderRetrieve, locationTransferOrderMaterials } from "@/api/stockTransfer";
import { columns } from "./columns";

export default {
  data() {
    return {
      columns,
      orderLoading: false,
      materialLoading: false,
      locationTransferOrder: undefined,
      locationTransferOrderItem: {},
      locationTransferMaterialItems: [],
    };
  },
  methods: {
    initData() {
      this.locationTransferOrder = this.$route.query.id;
      this.orderLoading = true;
      document.getElementById("jsbarcode").html = "";
      locationTransferOrderRetrieve({ id: this.locationTransferOrder })
        .then((data) => {
          this.locationTransferOrderItem = data;
          var jsbarcode = new JsBarcode(this.$refs.jsbarcode, data.number, {
            format: "CODE128",
            width: 2,
            height: 35,
            displayValue: true,
            background: "#ffffff",
            lineColor: "#000000",
          });
        })
        .finally(() => {
          this.orderLoading = false;
        });

      this.materialLoading = true;
      locationTransferOrderMaterials({ id: this.locationTransferOrder })
        .then((data) => {
          this.locationTransferMaterialItems = data;
        })
        .finally(() => {
          this.materialLoading = false;
        });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style>
.jsbarcode {
  float: right;
}
</style>
